import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TripCheckoutComponent } from "./trip-checkout.component";
import { TripCheckoutRoutingModule } from "./trip-checkout-routing.module";
import { TicketHeroModule } from "src/app/libs/ui/components/ticket-hero/ticket-hero.module";
import { SearchFormModule } from "src/app/libs/ui/components/search-form/search-form.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from '@angular/material/form-field';
import { CurrencyExchangeConverterModule } from "src/app/libs/common/pipes/currency-exhange-converter/currency-exhange-convertermodule";
import { I18nModule } from "src/app/core/languages-support/i18n.module";
import { AppSupportedLanguages } from "src/app/core/languages-support/i18n-config.service";

@NgModule({
    declarations: [TripCheckoutComponent],
    imports: [
        CommonModule,
        TicketHeroModule,
        TripCheckoutRoutingModule,
        SearchFormModule,
        FormsModule,
        I18nModule.forRoot(AppSupportedLanguages),
        ReactiveFormsModule,
        MatFormFieldModule,
        CurrencyExchangeConverterModule
    ]
})
export class TripCheckoutModule {}
